<template>
  <PrintPage :pageNumber="pageNumber">
    <template v-slot:header>
      <slot>
        <PrintHeaderSSPSlim />
      </slot>
    </template>

    <AttachmentsPrintGrid
      :attachments="project.gakAttachments"
      fieldName="gakAttachments"
      :maxImages="4"
    />

    <AttachmentsPrintGrid
      :attachments="project.serviceZsSerialNumberAttachments"
      fieldName="serviceZsSerialNumberAttachments"
      :maxImages="4"
    >
    </AttachmentsPrintGrid>
    <AttachmentsPrintGrid
      :attachments="project.serviceZsPostCounterAreaAttachments"
      fieldName="serviceZsPostCounterAreaAttachments"
      :maxImages="4"
    />
  </PrintPage>
</template>

<script>
import PrintPage from '@/components/Print/PrintPage';
import PrintHeaderSSPSlim from '@/components/Print/PrintHeaderSSPSlim';
import AttachmentsPrintGrid from '@/components/Print/AttachmentsPrintGrid';
import { range } from '@/helpers/math.js';

export default {
  name: 'ElectricMeterPrintPage2',
  components: {
    PrintPage,
    PrintHeaderSSPSlim,
    AttachmentsPrintGrid,
  },
  props: {
    project: null,
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },
  computed: {},
  methods: { range },
};
</script>
